import { CBadge } from '@coreui/react';
import { ENRICHMENT_COLOR, ENRICHMENT_DESCRIPTION_B2B, ENRICHMENT_DESCRIPTION_B2C } from '../../../../../../constants';
import CTooltip from '../../../../../migration/CTooltip';

export const enrichType = (data) => {
     const { enrichB2B, enrichB2C } = data;

     return (
          <>
               <CTooltip
                    content={
                         <>
                              <h6>{enrichB2C}</h6>
                              <span>{ENRICHMENT_DESCRIPTION_B2C[enrichB2C] || 'The person has not been enriched with B2C profile data'}</span>
                         </>
                    }
               >
                    <CBadge color={ENRICHMENT_COLOR[enrichB2C] || 'secondary'} className='mr-2' style={{cursor: "pointer"}}> B2C </CBadge>
               </CTooltip>
               <CTooltip
                    content={
                         <>
                              <h6>{enrichB2B}</h6>
                              <span>{ENRICHMENT_DESCRIPTION_B2B[enrichB2B] || 'The person has not been enriched with B2B profile data'}</span>
                         </>
                    }
               >
                    <CBadge color={ENRICHMENT_COLOR[enrichB2B] || 'secondary'} className='mr-2' style={{cursor: "pointer"}}> B2B </CBadge>
               </CTooltip>
          </>
     )
}